module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0084.7157a417.jpg";